import React from 'react';
import { Fab, Zoom } from '@mui/material';
import { AutoAwesome as AiIcon } from '@mui/icons-material';
import { useAppDispatch, useAppSelector } from '@/store';
import { setAiChatOpen } from '@/store/slices/uiSlice';
import { useKiFunktion } from '@/hooks/useKiFunktion';
import { CHAT_ORANGE, CHAT_ORANGE_AKTIV } from './chat-farben';

/**
 * Der Einstieg zum Co-Auditor.
 *
 * Er schwebt unten rechts, weil das die Stelle ist, an der Menschen einen
 * Assistenten suchen. Vorher lag derselbe Weg hinter einem Umschalter im
 * Suchdialog — technisch dasselbe, praktisch unauffindbar. Ohne das Recht auf
 * die Bestandsfrage erscheint er gar nicht; ein Angebot, das nicht gilt, wird
 * nicht angeboten.
 */
export const AiChatButton: React.FC = () => {
  const dispatch = useAppDispatch();
  const offen = useAppSelector((s) => s.ui.aiChatOpen);
  const ki = useKiFunktion('record_question');

  if (!ki.verfuegbar) return null;

  return (
    <Zoom in={!offen}>
      {/*
        Ein runder Knopf mit Funkelsymbol sagt niemandem, was dahinter steckt.
        Beschriftet ist er ein Angebot, unbeschriftet eine Verzierung — und
        genau daran krankte der alte Weg über den Umschalter im Suchfeld.
      */}
      <Fab
        variant="extended"
        onClick={() => dispatch(setAiChatOpen(true))}
        aria-label="Co-Auditor fragen"
        sx={{
          position: 'fixed',
          bottom: 28,
          right: 28,
          zIndex: (t) => t.zIndex.drawer - 1,
          px: 2.5,
          height: 52,
          gap: 1,
          fontSize: '0.95rem',
          fontWeight: 600,
          textTransform: 'none',
          // Heller Grund mit dunklem Text statt Weiß auf Dunkelorange: Das
          // alte Orange lag mit 3,09 genau auf der Grenze, ab der weißer Text
          // noch lesbar heißt. Heller ging damit nur, indem der Text dunkel
          // wird — so sind es 7,06, und der Knopf wirkt zugleich leichter.
          bgcolor: CHAT_ORANGE,
          color: 'primary.dark',
          boxShadow: 6,
          '&:hover': { bgcolor: CHAT_ORANGE_AKTIV, color: '#fff', boxShadow: 10 },
        }}
      >
        <AiIcon />
        Co-Auditor fragen
      </Fab>
    </Zoom>
  );
};
